var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectNew = function SvgIconSubjectNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-sujets-new",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1.999 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(0 4)",
    fill: "#ebebeb",
    d: "M0 0h13v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M225.2 99.1h-5a1 1 0 0 1 0-2h5a1 1 0 1 1 0 2Z",
    transform: "translate(-216.197 -85.104)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M225.2 95.1h-5a1 1 0 0 1 0-2h5a1 1 0 1 1 0 2Z",
    transform: "translate(-216.197 -85.104)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M231.68 85.735a.5.5 0 0 0-.806-.513L223.2 91.6h4.845l-1.327 4.868a.5.5 0 0 0 .805.513L235.2 90.6h-4.845Z",
    transform: "translate(-217.197 -85.104)",
    fill: "#f54c3c"
  }))));
};
export { SvgIconSubjectNew as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWpldHMtbmV3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cmVjdCBpZD0iYXJlYSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjZjJmMmYyIiBvcGFjaXR5PSIwIi8+CiAgPGcgaWQ9Imljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuOTk5IDEpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMiIgd2lkdGg9IjEzIiBoZWlnaHQ9IjE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDQpIiBmaWxsPSIjZWJlYmViIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xNiIgZGF0YS1uYW1lPSJQYXRoIDE2IiBkPSJNMjI1LjIsOTkuMWgtNWExLDEsMCwwLDEsMC0yaDVhMSwxLDAsMSwxLDAsMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTYuMTk3IC04NS4xMDQpIiBmaWxsPSIjYTBhMGEwIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xNyIgZGF0YS1uYW1lPSJQYXRoIDE3IiBkPSJNMjI1LjIsOTUuMWgtNWExLDEsMCwwLDEsMC0yaDVhMSwxLDAsMSwxLDAsMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTYuMTk3IC04NS4xMDQpIiBmaWxsPSIjYTBhMGEwIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xOCIgZGF0YS1uYW1lPSJQYXRoIDE4IiBkPSJNMjMxLjY4LDg1LjczNWEuNS41LDAsMCwwLS44MDYtLjUxM0wyMjMuMiw5MS42aDQuODQ1bC0xLjMyNyw0Ljg2OGEuNS41LDAsMCwwLC44MDUuNTEzTDIzNS4yLDkwLjZoLTQuODQ1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxNy4xOTcgLTg1LjEwNCkiIGZpbGw9IiNmNTRjM2MiLz4KICA8L2c+Cjwvc3ZnPgo=";